module.exports = __webpack_public_path__ + "media/images/riders/small/CONNOR_FEARON-78329b7b9dac0cd9929ac65df88c3669.png";